import { Api } from "@/types/api/api";

export class GeneratedApi<SecurityDataType> extends Api<SecurityDataType> {
  constructor(baseUrl: string) {
    super({ baseURL: baseUrl });
  }
}
